module.exports = __webpack_public_path__ + "img/ecd1b37.jpg";